const ResendForgotPasswordCodeForm = {
  label: `Didn't get the code?`,
  actions: {
    submitButton: {
      label: 'Resend Code',
      dataTestId: 'resend-button',
    },
  },

  messages: {},
};

export default ResendForgotPasswordCodeForm;
